<template>
  <div class="special_detail" @touchmove="preLoad(getPre)">
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
        class="special_detail_list"
        @click="toLookDetail(item.id)"
      >
        <img :src="item.bannerPic" alt="" />
        <div :class="index == list.length - 1 ? '' : 'vux-1px-b'">
          <p class="title">{{ item.name }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { facing } from '@/api/ajax.js';
import { loadMore } from '@/Mixin/loadMore.js';
export default {
  name: '',
  mixins: [loadMore],
  data() {
    return {
      list: [],
      pages: {
        pageNo: 1,
        pageSize: 10
      },
      loadFlag: true
    };
  },
  methods: {
    // 文章详情页面
    toLookDetail(specialId) {
      this.$router.push({ name: 'special', params: { id: specialId } });
    },
    getList(data) {
      if (this.loadFlag) {
        this.loadFlag = false;
        facing.specialList(data).then(res => {
          let resList = res.data.data.list;
          resList.filter(item => {
            this.list.push(item);
          });
          if (!res.data.data.hasNextPage) {
            this.loadFlag = false;
            return false;
          }
          this.pages.pageNo += 1;
          this.loadFlag = true;
        });
      }
    },
    getPre() {
      this.getList(this.pages);
    }
  },
  created() {
    this.getPre();
  }
};
</script>
<style lang="less" scoped>
@import '../../../public/style/g.less';
.special_detail {
  .special_detail_list {
    padding: 0.43rem 0.33rem 0 0.33rem;
    img {
      width: 100%;
      height: 4.53rem;
      background-size: 100% 100%;
    }
    .title {
      padding: 0.15rem 0 0.31rem;
      width: 90%;
      font-size: 0.4rem;
      font-weight: bold;
      color: #191919;
      .textLimit();
    }
  }
}
</style>
